<template>
	<v-toolbar app height="40" class="media-print header-style header-responsive">
		<v-container fluid py-0>
			<v-layout justify-space-between align-center>
				<v-flex xs1 class="wrapper-btn-siderbar">
					<button
						@click="$emit('open-sidebar')"
						class="btn-siderbar">
						<img
							v-if="mini"
							src="/static/img/sidebar/menu.svg"
							alt="menu-bars"
							width="19px"
						>
						<img
							v-else
							src="/static/img/sidebar/close.svg"
							alt="menu-bars"
							width="19px"
							height="13px"
						>
					</button>
				</v-flex>
				<v-flex text-xs-right>
					<div class="flex-item justify-end align-center">
						<button
							class="add-btn-container mr-2"
							@click="goToNewCompany"
						>
							<v-icon dark>add</v-icon>
						</button>
						<HeaderSelect
							return-object
							placeholder="Seleccione una Empresa"
							class="select"
							item-text="name"
							item-value="id"
							:disabled="$route.meta.noChangeCompany"
							:height="23"
							:items="getGlobalSubsidiaries"
							:value="currentSubsidiary.id"
							@input="$setCurrentSubsidiary"
						/>
						<v-menu>
							<button
								type="button"
								slot="activator"
							>
								<div class="add-btn-wrapper">
									<div class="add-btn-icon">
										<v-icon dark>arrow_drop_down</v-icon>
									</div>
									<p class="add-btn-text">Acciones</p>
								</div>
							</button>
							<v-list>
								<router-link
									class="company-modules-route"
									v-for="(item, index) in shortcuts"
									:key="index"
									:disabled="noSubsidiarySelected"
									:to="getRoute(item)"
								>
									<v-list-tile>

										<app-tooltip-button
											class="no-movil"
											:img="item.icon"
											:text="item.title"
										/>

										{{ item.title }}
									</v-list-tile>
								</router-link>
							</v-list>
						</v-menu>
						<div class="separate"></div>
						<div class="profile-image-container">
							<button @click="showMenu = !showMenu" tabindex="-1" class="d-flex">
								<img
									class="mr-2"
									:src="userAvatar"
									alt="Imagen de Perfil de Usuario"
									height="20"
									width="20"
								>
								<span class="user-name">{{userName || 'Nombre del Usuario'}}</span>
							</button>
							<div class="content-menu" v-if="showMenu">
								<div class="text-xs-center">
									<button @click="openModal">Actualizar datos</button>
								</div>
								<div class="text-xs-center">
									<button @click.prevent="logout">Cerrar sesión</button>
								</div>
							</div>
						</div>
					</div>
				</v-flex>
			</v-layout>
			<v-dialog
				v-model="activateModal"
				persistent
				width="400">
				<v-card>
					<v-card-title class="title-data">
						<h5 caption class="text-uppercase">Actualizar datos</h5>
					</v-card-title>
					<v-divider></v-divider>
					<v-layout mx-4 mt-3>
						<v-flex xs12>
							<h5 class="text-uppercase"><u>Datos del contador</u></h5>
						</v-flex>
					</v-layout>
					<v-layout row wrap mx-4 my-4>
						<v-flex xs12 md6 px-3>
							<base-input
								label="Nombre de usuario"
								v-model="model.userName"
							/>
						</v-flex>
						<v-flex xs12 md6 px-3>
							<base-input
								label="Teléfono"
								v-model="model.phone"
							/>
						</v-flex>
						<v-flex xs12 md6 px-3>
							<base-input
								label="Número de Cédula"
								v-model="model.numberDocument"
							/>
						</v-flex>
					</v-layout>
					<v-card-actions>
						<v-layout mx-4 justify-end>
							<v-flex xs6 md4>
								<v-btn
									color="#ff002b"
									:style="`color: #fff !important`"
									small
									@click="closeModal"
								>
									Cancelar
								</v-btn>
							</v-flex>
							<v-flex xs6 md4>
								<v-btn
									color="teal darken-1"
									:style="`color: #fff !important`"
									small
									@click="updateData"
								>
									Actualizar
								</v-btn>
							</v-flex>
						</v-layout>
					</v-card-actions>
				</v-card>
			</v-dialog>
		</v-container>
	</v-toolbar>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import appTooltipButton from '@/components/shared/app-tooltip-button';
import baseInput from '@/components/shared/inputs/base-input';

async function created() {
	const dataUserInfo = typeof this.$userInfo === 'string' ? JSON.parse(this.$userInfo) : this.$userInfo;
	const params = {
		customerId: dataUserInfo ? dataUserInfo.subsidiary.customerId : null,
	};
	await this.$loadSubsidiaries({ context: this, params });
	const { subsidiaryId, subsidiaryName } = this.$route.params;
	if (subsidiaryId && subsidiaryName) {
		const id = Number(subsidiaryId);
		const currentSubsidiary = this.getGlobalSubsidiaries.find(sub => sub.id === id);
		this.$setCurrentSubsidiary(currentSubsidiary);
	} else if (this.getGlobalSubsidiaries.length === 1) {
		const currentSubsidiary = this.getGlobalSubsidiaries.find(sub => sub.companyId != null);
		this.$setCurrentSubsidiary(currentSubsidiary);
	}
}

function openNotifications() {
	this.$emit('open-notifications-event');
}

async function openModal() {
	let { user } = {};
	if (typeof this.$userInfo === 'string') {
		user = JSON.parse(this.$userInfo);
	} else {
		user = this.$userInfo;
	}
	this.idUserCompany = user.auxiliary.id;
	this.model.userName = user.auxiliary.userName;
	this.model.phone = user.auxiliary.phone;
	this.model.numberDocument = user.auxiliary.numberDocument;
	this.model.email = user.auxiliary.email;
	this.activateModal = true;
	this.showMenu = false;
}

function closeModal() {
	this.activateModal = !this.activateModal;
}

async function updateData() {
	try {
		await this.$http.patch(`auxiliary/${this.idUserCompany}`, this.model);
		this.showNotification('Contador actualizado correctamente. Para ver los cambios es necesario reinicar sesión');
	} catch (error) {
		this.showGenericError();
	} finally {
		this.closeModal();
	}
}

async function logout() {
	window.localStorage.clear();
	await this.$httpAcl.post('logout', {
		headers: {
			authorization: `Bearer ${this.token}`,
		},
	});
	this.$clearUser();
	this.$router.push({ name: 'login' });
}

function goToNewCompany() {
	if (this.$route.name === 'companies') {
		this.goTo('company-new', { params: { ...this.$route.params } });
	} else {
		this.goTo('company-new');
	}
}

function noSubsidiarySelected() {
	return !(this.currentSubsidiary && this.currentSubsidiary.name);
}

function getRoute({ route }) {
	if (!this.noSubsidiarySelected) {
		if (route === 'costs-centers') {
			const { id, name } = this.currentSubsidiary;
			return { name: route, query: { subsidiaryId: id, subsidiaryName: name.split(' ').join('-') } };
		} else if (route === 'accounting-modules') {
			const { id, name, customerId } = this.currentSubsidiary;
			return { name: 'accounting-modules', query: { subsidiaryId: id, name, customerId } };
		} else if (route === 'accounting-periods') {
			const { id: subsidiaryId, name } = this.currentSubsidiary;
			const subsidiaryName = name.split(' ').join('-');
			return { name: 'accounting-periods', params: { subsidiaryId, subsidiaryName } };
		} else if (route === 'accounting-plans') {
			const { id } = this.currentSubsidiary;
			return { name: 'accounting-plans', params: { subsidiaryId: id } };
		}
	}
	return '';
}

function data() {
	return {
		showMenu: false,
		shortcuts: [
			{ icon: '/static/img/icons/centro-costos.svg', title: 'Centro de costos', route: 'costs-centers' },
			{ icon: '/static/img/icons/plan-contable.svg', title: 'Plan contable', route: 'accounting-plans' },
			{ icon: '/static/img/icons/periodo-contable.svg', title: 'Periodos contables', route: 'accounting-periods' },
			{ icon: '/static/img/icons/modulo.svg', title: 'Modulos', route: 'accounting-modules' },
		],
		activateModal: false,
		model: {
			userName: null,
			phone: null,
			numberDocument: null,
			email: null,
		},
		idUserCompany: null,
	};
}

export default {
	name: 'app-header',
	components: {
		appTooltipButton,
		HeaderSelect: () => import('@/components/shared/inputs/header-select'),
		baseInput,
	},
	computed: {
		...mapGetters('user', [
			'userAvatar',
			'userName',
		]),
		...mapGetters('subsidiary', [
			'currentSubsidiary',
			'getGlobalSubsidiaries',
		]),
		noSubsidiarySelected,
	},
	created,
	data,
	methods: {
		...mapActions('user', {
			$clearUser: 'clearUser',
		}),
		...mapActions('subsidiary', {
			$setCurrentSubsidiary: 'setCurrentSubsidiary',
			$loadSubsidiaries: 'loadSubsidiaries',
		}),
		getRoute,
		logout,
		openNotifications,
		goToNewCompany,
		openModal,
		closeModal,
		updateData,
	},
	props: {
		quantityNotifications: {
			default: 0,
			type: Number,
		},
		mini: Boolean,
	},
};
</script>

<style lang="scss" scoped>
.header-style {
	box-shadow: 0 2px 4px 0 rgba(206, 206, 206, 0.5) !important;
}

.container {
	height: 100%;
	@media (max-width: 599px) {
		margin-left: 0px !important;
		margin-right: 0px !important;
	}

	.layout {
		height: 100%;
	}

	@media (max-width: 959px) {
		padding: 10px
	}
}

.v-toolbar {
	background-color:  #fff;
	box-shadow: none;
	height: 40px;
}
.theme--light.v-toolbar {
	background-color: #02979b!important;
}

.flex-item {
	display: flex;
}

.profile {
	&-name {
		color: map-get($colors, black);
		font-family: map-get($fonts, open-bold);
		font-size: 13px;
		font-weight: bold;
		padding-right: 9px;
		vertical-align: super;
	}

	&-image-container {
		align-items: center;
		border-radius: 100%;
		display: inline-flex;
		font-size: map-get($sizes, small);
		height: 20px;
		justify-content: center;
	}
}

.notification {
	&-btn {
		background-color: transparent !important;
		border-radius: 0px;
		box-shadow: none;
		height: auto;
		margin: 0px 25px 0px 0px;
		max-height: 40px;
		min-width: auto;
		width: auto;
	}

	&-quantity {
		background-color: map-get($colors, border);
		border-radius: 100%;
		color: white;
		font-family: map-get($fonts, lato-regular);
		font-size: map-get($sizes, small10);
		height: 12px;
		right: 15px;
		line-height: 10px;
		position: absolute;
		text-align: center;
		top: 8px;
		width: 12px;
		z-index: 2;
	}
}

.btn-notification {
	color: map-get($colors, base) !important;

	.v-icon {
		color: inherit !important;
	}
}

.separate {
	border: solid 1px color(grey);
	height: 25px;
	margin: 0 10px;
}

.add-btn-container {
	background-color: #02979b!important;
	border-radius: 50%;
	@media (max-width: 768px) {
		background-color: #33cfc7!important;
	}
}

.user-name {
	color: color(secondary) !important;
	white-space: nowrap;
}

.select {
	max-width: 250px;
}

.header-responsive {
	@media (max-width: 954px) {
		border-bottom: 3px solid #006edb;
		padding-left: 0px !important;
		.separate, .profile-image-container {
			display: none;
		}
	}
}

.logo-quipu-image {
	&:focus {
		outline: none;
	}
}

.wrapper-btn-siderbar {
	border-right: 1px solid map-get($colors, grey-icon);
	margin-right: 12px;
	padding: 4px 10px 0 0;

	@media (min-width: 768px) {
		display: none;
	}
}
.company-modules-route {
	text-decoration: none;
	width: 100%;

	&[disabled] {
		cursor: not-allowed;
	}
}
.add-btn {
	&-wrapper {
		align-items: center;
		display: flex;
	}
	&-icon {
		background-color: color('btn-green');
		border-radius: 50%;
		height: 28px;
		margin-left: 5px;
		width: 28px;

		@media (min-width: 768px) {
			margin-left: 0px;
			transform: translateX(18px);
		}
	}
	&-text {
		display: none;

		@media (min-width: 768px) {
			background-color: #b2dd00 !important;
			border-radius: 17px;
			color: white;
			font-weight: bold;
			display: block;
			font-size: 12px;
			padding: 0.1rem 1rem;
			padding-left: 1.65rem;
			margin-bottom: 0;
		}
	}
}
.profile-image-container {
	position: relative;
}
.add-btn-icon {
	background-color: #02979b!important;
	@media (max-width: 768px) {
		background-color: #33cfc7 !important;
	}
}

.content-menu {
	bottom: -70px;
	border: 1px solid color(border-action);
	box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.05);
	border-radius: 5px;
	background: white;
	color: color(text);
	font-size: 13px;
	position: absolute;
	padding: 8px 20px;
	right: 0;
	width: 150px;
	z-index: 400;

	&::before {
		background: color(white);
		border: 1px solid color(border-action);
		border-bottom-width: 0;
    	border-right-width: 0;
		content: '';
		height: 15px;
		left: 70px;
    	position: absolute;
		top: -9px;
		width: 15px;
		-webkit-transform: rotate(45deg);
		-moz-transform: rotate(45deg);
		-ms-transform: rotate(45deg);
		-o-transform: rotate(45deg);
		transform: rotate(45deg);
	}
}

.title-data {
	background-color: #00897b;
	color: #fff;
}

</style>



// WEBPACK FOOTER //
// src/components/shared/app-header.vue